import { render } from "./DetalharPlanoMatricula.vue?vue&type=template&id=8f1f0f6e&scoped=true"
import script from "./DetalharPlanoMatricula.vue?vue&type=script&lang=js"
export * from "./DetalharPlanoMatricula.vue?vue&type=script&lang=js"

import "./DetalharPlanoMatricula.vue?vue&type=style&index=0&id=8f1f0f6e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f1f0f6e"]])

export default __exports__